import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	useCreateCustomFieldDefinitionMutation,
	CreateTicketingCustomFieldDefinitionInput,
} from './__generated__/useCreateCustomFieldDefinitionMutation.graphql';

const mutation = graphql`
	mutation useCreateCustomFieldDefinitionMutation($input: CreateTicketingCustomFieldDefinitionInput!) {
		createTicketingCustomFieldDefinition(input: $input) {
			clientMutationId
			customFieldDefinitionEdge {
				cursor
				node {
					id
					name
					key
					fieldType
					options
					readOnly
					requiredOnResolution
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateTicketingCustomFieldDefinitionInput,
	onCompleted?: (r: useCreateCustomFieldDefinitionMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useCreateCustomFieldDefinitionMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useCreateCustomFieldDefinitionMutation'};
